document.addEventListener('DOMContentLoaded', () => {
    initPagination();
});

function initPagination() {
    const pagination = document.querySelector('.pagination');
    if (!pagination) return;

    const page_numbers = pagination.getElementsByClassName('page-numbers');
    for (let i = 0; i < page_numbers.length; i++) {
        page_numbers[i].removeAttribute('href');
    }

    pagination.removeEventListener('click', handlePaginationClick);
    pagination.addEventListener('click', handlePaginationClick);
}

async function handlePaginationClick(event) {
    event.preventDefault();

    const target = event.target;
    if (!target.classList.contains('page-numbers') && !target.classList.contains('next') && !target.classList.contains('prev')) {
        return;
    }

    const pagination = event.currentTarget;
    let currentPage = parseInt(pagination.getAttribute('data-page')) || 1;

    if (target.classList.contains('next')) {
        currentPage += 1;
    } else if (target.classList.contains('prev')) {
        currentPage = Math.max(1, currentPage - 1);
    } else {
        currentPage = parseInt(target.textContent.trim()) || 1;
    }
    const id = pagination.getAttribute('data-id');
    const number = parseInt(pagination.getAttribute('data-num'));
    const type = pagination.getAttribute('data-type');
    const type_card = pagination.getAttribute('data-type-card');

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        mode: 'no-cors'
    };

    const form = new FormData();
    form.append('action', 'update_pagintation_link');
    form.append('id', id);
    form.append('number', number);
    form.append('type', type);
    form.append('page', currentPage);
    form.append('type_card', type_card);

    const params = new URLSearchParams(form);
    options.body = params;

    let response = await fetch('/wp-admin/admin-ajax.php', options);
    let html = await response.text();
    if (html) {
        const newsList = document.querySelector('.section-catalog__block');
        newsList.innerHTML = html;

        pagination.setAttribute('data-paged', currentPage);
        initPagination();
    }
}
